import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import MenuItem from '@material-ui/core/MenuItem';

import ApiEntitySelectDialog from '../../../../components/ApiEntitySelectDialog/ApiEntitySelectDialog';
import CustomInput, { Props as CustomInputProps } from '../../../../components/CustomInput/CustomInput';
import ProcessDetailsDialog from '../../../../dialogs/ProcessDetailsDialog/ProcessDetailsDialog';
import Process from '../../../../types/Process';
import api from '../../../../utils/api';

interface Props {
    baseInputProps: Omit<CustomInputProps, 'name'>;
    companyId: number;
}

const ProcessSelect = (props: Props) => {
    const { baseInputProps, companyId } = props;
    const { data, handleAttributeChange } = baseInputProps;

    const { t } = useTranslation();

    const [processData, setProcessData] = useState<Process | null>(null);

    const [isSelectModalOpen, setIsSelectModalOpen] = useState(false);
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

    const onProcessSelect = useCallback((selectedProcessId?: number) => {
        if (selectedProcessId && handleAttributeChange) {
            handleAttributeChange('processId', selectedProcessId.toString());
        }
        setIsSelectModalOpen(false);
    }, [handleAttributeChange]);

    const openDetailsDialog = useCallback(() => {
        setIsDetailsModalOpen(true);
    }, []);

    const onDetailsClose = useCallback((selectedProcessId?: number) => {
        onProcessSelect(selectedProcessId);
        setIsDetailsModalOpen(false);
    }, [onProcessSelect]);

    const processId = data.processId;

    useEffect(() => {
        if (processId) {
            api.request('/companies/' + companyId + '/processes/' + processId).then((res) => {
                setProcessData(res);
            });
        }
        else {
            setProcessData(null);
        }
    }, [companyId, processId]);

    const map = (process: Process) => {
        return {
            id: process.id,
            name: process.name,
            description: process.description,
        };
    };

    const selectProps = {
        open: false,
        onOpen: () => setIsSelectModalOpen(true)
    };

    return (
        <>
            <CustomInput {...baseInputProps} name='processId' select SelectProps={selectProps} >
                {processData ? (
                    <MenuItem value={processData.id} >
                        {processData.name}
                    </MenuItem>
                ) : (
                    <MenuItem />
                )}
            </CustomInput>

            <ApiEntitySelectDialog
                open={isSelectModalOpen}
                onClose={onProcessSelect}
                title={t('dialogs.process_select.title')}
                noEntityFoundMessage={t('dialogs.process_select.no_process_found')}
                url={'/companies/' + companyId + '/processes'}
                map={map}
                newEntityBtnPosition='footer'
                onNewEntityClick={openDetailsDialog}
                newEntityBtnText={t('dialogs.process_select.new_process')}
            />

            <ProcessDetailsDialog open={isDetailsModalOpen} onClose={onDetailsClose} companyId={companyId} processId={0} />
        </>
    );
};

export default ProcessSelect;
